import {
  SET_MULTIPLE_SHOW,
  SET_MUTILE_FIND_DATA,
  SET_CREATE_MUTILE,
} from "../types";

//顯是客製搜尋
export const showHideMultipleView = (result) => (dispatch) => {
  dispatch({
    type: SET_MULTIPLE_SHOW,
    payload: result,
  });
};

//新增客製的開關
export const setCreateMutileData = (result) => (dispatch) => {
  dispatch({
    type: SET_CREATE_MUTILE,
    payload: result,
  });
};

//取得客製搜尋
export const getMultipleFindData = () => (dispatch) => {
  // let multipleFindData = [{
  //     title:'1111',
  //     items:[
  //         {findText:'222',replaceText:'333'},
  //         {findText:'555',replaceText:'999'}
  //     ]
  // },{
  //     title:'aaa',
  //     items:[
  //         {findText:'fff',replaceText:'gggg'},
  //         {findText:'cccc',replaceText:'nnn'}
  //     ]
  // }];

  let multipleFindData = [];
  if (localStorage.multipleFindData) {
    const stringData = localStorage.getItem("multipleFindData");
    dispatch({
      type: SET_MUTILE_FIND_DATA,
      payload: JSON.parse(stringData),
    });
    return JSON.parse(stringData);
  } else {
    return multipleFindData;
  }
};

//取得客製搜尋
export const removeMultipleFindItem =
  (multipleFindData, index) => (dispatch) => {
    multipleFindData.splice(index, 1);

    dispatch({
      type: SET_MUTILE_FIND_DATA,
      payload: multipleFindData,
    });

    //儲存
    saveData(multipleFindData);
  };

//複製客製搜尋
export const duplicateMultipleFindItem =
  (multipleFindData, index) => (dispatch) => {
    let newmultipleFindData = [];

    multipleFindData.forEach(function (obj, objIndex) {
      newmultipleFindData.push(obj);
      if (objIndex === index) {
        let newItem = { title: "", items: [] };
        newItem.title = `${obj.title} copy`;
        newItem.items = obj.items;

        newmultipleFindData.push(newItem);
      }
    });

    dispatch({
      type: SET_MUTILE_FIND_DATA,
      payload: newmultipleFindData,
    });

    //儲存
    saveData(newmultipleFindData);
  };

//新增物件
export const addNewMultipleFindData =
  (multipleFindData, newObj) => (dispatch) => {
    multipleFindData.push(newObj);

    //儲存
    dispatch({
      type: SET_MUTILE_FIND_DATA,
      payload: multipleFindData,
    });

    //儲存
    saveData(multipleFindData);
  };

//更新物件
export const updateMultipleFindData = (multipleFindData) => (dispatch) => {
  dispatch({
    type: SET_MUTILE_FIND_DATA,
    payload: multipleFindData,
  });

  //儲存
  saveData(multipleFindData);
};

function saveData(multipleFindData) {
  localStorage.setItem("multipleFindData", JSON.stringify(multipleFindData));
}



// WEBPACK FOOTER //
// ./src/actions/find/mutileFindAction.js